// extracted by mini-css-extract-plugin
module.exports = {"container":"_3tI-W3pMDitLuEDMkxsCvJ","button":"_3TJd6dnlLcE-_GuYZR4uaP primaryColor"};